const LEGAL_LINKS = [
  { href: '/legal/offer/', label: 'Публичная оферта' },
  { href: '/legal/privacy/', label: 'Политика конфиденциальности' },
  {
    href: '/legal/personal-data-consent/',
    label: 'Согласие на необязательную аналитику',
  },
  {
    href: '/legal/acceptable-use-ai/',
    label: 'Правила допустимого использования и ИИ',
  },
  { href: '/legal/account-member-terms/', label: 'Условия аккаунта' },
  { href: '/legal/business-terms/', label: 'Условия для бизнеса' },
  {
    href: '/legal/business-data-processing/',
    label: 'Приложение об обработке данных заказчика',
  },
] as const

export function LegalDocumentLinks() {
  return (
    <nav aria-label="Правовые документы" className="mt-8 grid gap-2 text-sm">
      {LEGAL_LINKS.map((link) => (
        <a
          className="text-muted-foreground underline underline-offset-4 hover:text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          href={`https://amitable.ru${link.href}`}
          key={link.href}
          rel="noopener noreferrer"
          target="_blank"
        >
          {link.label}
        </a>
      ))}
    </nav>
  )
}
